module.exports = __webpack_public_path__ + "img/bg_overlay_register.01220286.png";